function isRecord(value: unknown): value is Record<string, unknown> {
  return typeof value === "object" && value !== null;
}

export function normaliseCustomFieldPaths(response: unknown): string[] {
  const candidates: unknown[] = [response];
  const inspectedCandidates = new Set<unknown>();
  const fieldListKeys = [
    "fieldPaths",
    "systemFields",
    "additionalProperties",
    "customFields",
    "fields",
    "data",
    "response",
  ] as const;

  while (candidates.length > 0) {
    const candidate = candidates.shift();

    if (Array.isArray(candidate)) {
      return candidate.filter((field): field is string => typeof field === "string");
    }

    if (!isRecord(candidate) || inspectedCandidates.has(candidate)) {
      continue;
    }

    inspectedCandidates.add(candidate);
    fieldListKeys.forEach((key) => candidates.push(candidate[key]));
  }

  return [];
}